import { actionTypes, errorTypes } from '@/types';
import { vRShowVideoMono, vRShowMono } from '@/tools/nativeInterfaceFunctions';
import { getLangValue } from '@/tools/languageValue';
import { getFigcaptionTitle, isIOS } from '@/tools/helpers';
import { i18n } from '@/tools/i18n';

export default {
	init() {
		[...this.$el.querySelectorAll('.post--image[operation-type="360"], .post--360')].forEach(post => {
			// Create missing icon
			const iconDiv = document.createElement('div');
			iconDiv.classList.add('element__icon');
			const caption = post.querySelector('.element__caption');
			caption.insertBefore(iconDiv, caption.firstChild);

			post.addEventListener('click', async event => {
				const postElement = event.currentTarget;
				const type = postElement.classList.contains('panoVideo') ? 'video' : 'image';
				const isStereo = postElement.classList.contains('stereo');

				// ------------------------------------
				// Use media id for getting the URL
				const $mediaId = post.querySelector('[media-id]');
				const mediaID = $mediaId ? $mediaId.getAttribute('media-id') : null;
				const url = getLangValue(this.$store.state.currentMediaObjectMap.get(mediaID).BigSources);

				if (type === 'video') {
					if (vRShowVideoMono(url)) return;
					if (isIOS()) {
						this.$store.dispatch(actionTypes.sendErrorMessage, {
							error: new Error(errorTypes.videoNotSupported),
						});
						return;
					}
				} else if (await vRShowMono(url)) {
					return;
				}

				this.$store.dispatch(actionTypes.OPEN_VRVIEWER, {
					type,
					url,
					isStereo,
				});
			});

			// screenreader compat
			const icon = post.querySelector('.element__fullimage');
			if (icon) {
				icon.setAttribute('role', 'button');
				icon.setAttribute('tabindex', 0);
				icon.setAttribute('aria-label', `${i18n.t('image360Show')} ${getFigcaptionTitle(post)}`);
			}

			const description = post.querySelector('.element__caption__text');
			if (description) {
				description.setAttribute('role', 'text');
				description.setAttribute('tabindex', 0);
				description.setAttribute('aria-label', `${i18n.t('imageDescription')} ${description.textContent}`);
			}
			[...post.querySelectorAll('.element__caption__headline, .element__caption__time')].forEach(element =>
				element.setAttribute('aria-hidden', true)
			);
		});
	},
};
